import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useSelector } from 'react-redux';
import * as R from 'ramda';
import { useAppDispatch } from '../../../../../hooks/hooks';
import PageLoader from '../../../../../components/PageLoader';
import LogisticsSettingsComponent from '../components/logistics.component';
import { logisticsSettings } from '../../../../../redux/logistics-settings/action';
import { selectLogisticsSettingsQueryItems } from '../../../../../redux/logistics-settings/selector';

const ManagementLogisticsSettings = () => {
    const dispatch = useAppDispatch()
    const logisticsSettingsQuery = useSelector(selectLogisticsSettingsQueryItems)
    const [isQuery, setIsQuery] = useState<boolean>(false)
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const [selectLogisticsSettings, setSelectLogisticsSettings] = useState<any>([])

    const fetchCatalogSettingsQueryById = () => {
        dispatch(logisticsSettings.query({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/logistics/query`,
            entity: 'logisticsSettings',
            jsonData: {
                Records: [
                    {
                        Id: 0
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true)
        })
    }

    const handleInnerFormChange: any = (event: any, field: string, data: any) => {
        const fields = R.split(
            '.',
            field
        );
        const value = { ...data, [fields[1]]: event }// inner data update
        setSelectLogisticsSettings({ ...selectLogisticsSettings, [fields[0]]: value });
    }

    useEffect(
        () => {
            fetchCatalogSettingsQueryById()
            setIsLoading(false)
        }, []
    )

    useEffect(
        () => {
            if (isQuery) {
                setSelectLogisticsSettings(logisticsSettingsQuery?.result?.items)
            }
        }, [isQuery]
    )

    const handleFormSubmit = async (event: any) => {
        event.preventDefault();
        await dispatch(logisticsSettings.resetAction({ actionType: 'update' }))
        await dispatch(logisticsSettings.update({
            url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/settings/logistics`,
            entity: 'logisticsSettings',
            jsonData: {
                Records: [
                    selectLogisticsSettings
                ]
            }
        }))
    }

    return (
        <>
            {isLoading ? <PageLoader /> :
                <LogisticsSettingsComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectLogisticsSettings={selectLogisticsSettings}
                    handleFormSubmit={handleFormSubmit}
                />
            }
        </>
    )
};

export default ManagementLogisticsSettings;